import React from "react";
import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import IntermediaryBanner from "@/components/sections/IntermediaryBanner";
import HowItWorks from "@/components/sections/HowItWorks";
import Benefits from "@/components/sections/Benefits";
import Calculator from "@/components/sections/Calculator";
import RepresentativeExample from "@/components/sections/RepresentativeExample";
import ConditionsTable from "@/components/sections/ConditionsTable";
import PartnerEntities from "@/components/sections/PartnerEntities";
import CreditUses from "@/components/sections/CreditUses";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import CreditoResponsable from "@/components/sections/CreditoResponsable";
import Footer from "@/components/sections/Footer";
import WhatsAppFloat from "@/components/sections/WhatsAppFloat";
import { useLeadDialog } from "@/components/sections/LeadDialog";

export default function Landing() {
  const { open } = useLeadDialog();
  const openRequest = () => open("landing");

  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid="landing-page">
      <Header onCtaClick={openRequest} />
      <main>
        <Hero onCtaClick={openRequest} />
        <IntermediaryBanner />
        <HowItWorks />
        <Benefits />
        <Calculator onCtaClick={openRequest} />
        <RepresentativeExample />
        <ConditionsTable />
        <PartnerEntities />
        <CreditUses />
        <Testimonials />
        <CreditoResponsable />
        <FAQ />
      </main>
      <Footer onCtaClick={openRequest} />
      <WhatsAppFloat />
    </div>
  );
}
